import React, { useContext } from "react";
import { RangeDate, From, To , FromB , ToB } from "components/general/RangeDate";
import { ContextResidueAndMovements } from "..";

export default function Dates() {
  const hook = useContext(ContextResidueAndMovements);

  return (
    <RangeDate>
      <FromB
        defaultValue={hook.from}
        onChange={(date) => hook.setRange(date, hook.to)}
      />
      <ToB
        defaultValue={hook.to}
        onChange={(date) => hook.setRange(hook.from, date)}
      />
      {/* <From
        selected={hook.from}
        required={!hook.isValidFrom}
        onChange={(date) => hook.setRange(date, hook.to)}
      />
      <To
        selected={hook.to}
        required={!hook.isValidTo}
        maxDate={new Date()}
        onChange={(date) => hook.setRange(hook.from, date)}
      /> */}
    </RangeDate>
  );
}
